export const DRIVER_PACKAGE_SUMMARY = "DRIVER_PACKAGE_SUMMARY";
export const DRIVER_PACKAGE_SUMMARY_SUCCESS = "DRIVER_PACKAGE_SUMMARY_SUCCESS";
export const DRIVER_PACKAGE_SUMMARY_ERROR = "DRIVER_PACKAGE_SUMMARY_ERROR";
export const DRIVER_PACKAGE_SUMMARY_CACHE_KEY = "DRIVER_PACKAGE_SUMMARY_CACHE_KEY";
export const FILTER_DATA = "FILTER_DATA";
export const FETCH_FROM_CACHE = "FETCH_FROM_CACHE"
export const TOGGLE_REFRESH_BUTTON = "TOGGLE_REFRESH_BUTTON"
export const UNASSIGNED_WEB_REJECTS = "unassignedRejectedCount";
export const UNASSIGNED_WEB_REJECTS_HEADING = "Unassigned Web Rejects";
export const STATION_COUNT_HEADER = "station.count.header";
export const STATION_LEVEL_HEADER_NAME = "Station level";
export const STATION_COUNT = "station.count";
export const DRIVER_COUNT_HEADER = "driver.count.header";

export const DRIVER_ASSIGNED_TRACKING_ID_LIST = "DRIVER_ASSIGNED_TRACKING_ID_LIST";
export const DRIVER_ASSIGNED_TRACKING_ID_LIST_SUCCESS = "DRIVER_ASSIGNED_TRACKING_ID_LIST_SUCCESS";
export const DRIVER_ASSIGNED_TRACKING_ID_LIST_ERROR = "DRIVER_ASSIGNED_TRACKING_ID_LIST_ERROR";
export const TRACKING_ID_LIST = "TrackingId List";

export const REFRESH_BUTTON_DISABLE_KEY = 'refresh.button.disable';
export const REFRESH_BUTTON_SUCCESS_MESSAGE = "Succesfully refreshed data";
export const REFRESH_BUTTON_ERROR_MESSAGE = "Error while refreshing data";
export const REFRESH_BUTTON = "Refresh Data";
export const REFRESH_BUTTON_INVOKED = "Refresh Button enabled after X";
export const REFRESH_BUTTON_DISABLE_TIME  = 120000; // Button disable for 2 mins
export const REFRESH_BUTTON_MESSAGE_ID = "refreshButtonMessage";

export const PRINT_DRIVER_PACKAGE_SUMMARY = "PRINT_DRIVER_PACKAGE_SUMMARY";
export const PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS = "PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS";
export const PRINT_DRIVER_PACKAGE_SUMMARY_ERROR = "PRINT_DRIVER_PACKAGE_SUMMARY_ERROR";
export const TOGGLE_PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON = "TOGGLE_PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON";
export const PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS_MESSAGE = "Successfully exported the DA package summary data"
export const PRINT_DRIVER_PACKAGE_SUMMARY_ERROR_MESSAGE = "Error while exporting the DA package summary data"
export const PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON_DISABLE_KEY = "print.driver.package.summary.disable";
export const PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON_INVOKED = "Export to CSV enabled after X";
export const PRINT_DRIVER_PACKAGE_SUMMARY_DISABLE_TIME = 120000; // Button disable for 2 mins
export const PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON = "Export to CSV";
export const PRINT_DRIVER_PACKAGE_SUMMARY_FILE_NAME = "DAPackageSummarySheet.csv";
export const PRINT_DA_BUTTON_MESSAGE_ID = "printDASheetButtonMessage";


// DriverLevel Response Index
export const DRIVER_NAME = "driverName";
export const DRIVER_ID = "driverId";

//StationLevel Response Index
export const ASSIGNED = "assigned";
export const DEPARTED = "departed";
export const REJECTED = "rejected";
export const DELTA = "delta";


// Cache expiry after 30 mins
export const CACHE_TTL = 1800000;
export const PAGE_SIZE = 50;

export const RESPONSE_TYPE = {
    SUCCESS:"success",
    ERROR: "error",
    WARN: "warning"
}

export const STATION_LEVEL_ATTRIBUTES = [
    [UNASSIGNED_WEB_REJECTS, "Unassigned WebRejects"],
    [ASSIGNED, "Assigned"],
    [DEPARTED, "OOR"],
    [REJECTED, "Web Rejects"],
    [DELTA, "Delta"]
];

export const DRIVER_ATTRIBUTES = [
    [DRIVER_NAME, "Driver level"],
    ["", ""],
    [ASSIGNED, "Assigned"],
    [DEPARTED, "OOR"],
    [REJECTED, "Web rejects"],
    [DELTA, "Delta"]
];

export const EXPORT_TO_CSV_HEADER =
    ["DriverName", "Delta TID","Web Reject TID"];



// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/constants/DriverPackageSummaryConstants.js